/**
 * All the various sliders in the project
 *
 * @author Yonita van Oudheusden <yonita@click.nl>
 * @author Rianne Oosthoek <rianne@click.nl>
 */
window.slider = function(){
    var self = this;
    var $slider = $('.js-slider');
    var $hero_slider = $('.js-hero-slider');
    var $usps_slider = $('.js-usps-slider');

    self.init = function(){
        if($slider.length > 0){
            self.initSlider();
        }
    };

    self.initSlider = function(){
        $slider.each(function(){
            var $this = $(this);
            // Only initialize Slick when there are more than 1 slides
            if( $this.find('.c-slide').length > 1 && !$this.hasClass('slick-initialized') ){
                $this.slick({
                    cssEase:        'ease-in-out',
                    slidesToShow:   1,
                    mobileFirst:    true,
                    arrows:         false,
                    dots:           true,
                    autoplay:       false,
                    autoplaySpeed:  1000,
                });
            }
        });
        // Bugfix for Safari on iOS, see https://github.com/kenwheeler/slick/issues/2677#issuecomment-287110111
        jQuery('.slick-slide').bind('touchstart', function(){});
    };

    self.initHeroSlider = function(){
        $hero_slider.each(function(){
            var $this = $(this);
            // Only initialize Slick when there are more than 1 slides
            if( $this.find('.c-slide').length > 1 && !$this.hasClass('slick-initialized') ){
                $this.slick({
                    cssEase:        'ease-in-out',
                    slidesToShow:   1,
                    mobileFirst:    true,
                    arrows:         false,
                    dots:           true,
                    autoplay:       true,
                    autoplaySpeed:  5000,
                });
            }
        });
        // Bugfix for Safari on iOS, see https://github.com/kenwheeler/slick/issues/2677#issuecomment-287110111
        jQuery('.slick-slide').bind('touchstart', function(){});
    };

    self.initUspsSlider = function(){
        $usps_slider.each(function(){
            var $this = $(this);
            // Only initialize Slick when there are more than 1 slides
            if( $this.find('.c-slide').length > 1 && !$this.hasClass('slick-initialized') ){
                $this.slick({
                    cssEase:        'ease-in-out',
                    slidesToShow:   1,
                    mobileFirst:    true,
                    arrows:         false,
                    dots:           false,
                    autoplay:       true,
                    autoplaySpeed:  3000,
                });
            }
        });
        // Bugfix for Safari on iOS, see https://github.com/kenwheeler/slick/issues/2677#issuecomment-287110111
        jQuery('.slick-slide').bind('touchstart', function(){});
    };
}



// WEBPACK FOOTER //
// ./resources/assets/js/frontend/components/slick-slider.js